/**
 * Dependencies
 */
import { get } from 'lodash'

/**
 * Return the tab count
 *
 * @param  {Object} state
 * @return {Integer}
 */
const tabCount = (state) => {
    return Object.keys(get(state.data, 'summary_context.tabs', {})).length
}

/**
 * Return the portfolio labels
 *
 * @param  {Object} state
 * @return {Array}
 */
const portfolioLabels = (state) => {
    return get(state.data, 'summary_context.labels', [])
}

/**
 * Portfolio Tabs
 *
 * @param  {Object} state
 * @return {Object}
 */
const portfolioTabs = (state) => {
    return get(state.data, 'summary_context.tabs', {})
}

export default {
    tabCount,
    portfolioTabs,
    portfolioLabels
}



// WEBPACK FOOTER //
// ./src/state/modules/portfolios/single/getters.js